import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { payrollStaffTpl } from '@/api/payroll';
import { baseHeaders } from 'util/axios-request';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  data: function data() {
    return {
      visible: false,
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      uploadUrl: baseURL + 'web/payroll_staff/uploadStaffPayInfoData',
      baseHeaders: baseHeaders(),
      fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadStatus: false,
      uploadTotalCount: 0,
      // 总数
      uploadSuccessCount: 0,
      // 成功数
      uploadFailCount: 0,
      // 失败数
      feedbackFileUrl: '',
      form: {
        name: ''
      }
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
    },
    handleExport: function handleExport(type) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return payrollStaffTpl({
                settlement_type: type
              });
            case 2:
              res = _context.sent;
              if (res && res.code === 1) window.open(res.data.template_url);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      } else {
        // this.listType = "text";
      }

      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(this.$t('730', {
          fileSize: this.fileSize
        }));
        return false;
      }
    },
    // 上传成功+
    successHandle: function successHandle(res, file) {
      if (this.$refs.upload.uploadFiles.length > 1) {
        this.$refs.upload.uploadFiles.splice(0, 1);
      }
      this.uploadTotalCount = 0; // 总数
      this.uploadSuccessCount = 0; // 成功数
      this.uploadFailCount = 0; // 失败数
      var response = res;
      var data = response.data;
      if (response && response.code === 1) {
        this.uploadStatus = true;
        if (data.upload_result_state === 1) {
          // 全部成功
          this.uploadTotalCount = data.upload_total_count;
          this.uploadSuccessCount = data.upload_success_count;
          this.uploadFailCount = data.upload_fail_count;
          this.$message.success(this.$t('935'));
          this.feedbackFileUrl = '';
        } else if (data.upload_result_state === 5) {
          // 部分成功
          this.uploadTotalCount = data.upload_total_count;
          this.uploadSuccessCount = data.upload_success_count;
          this.uploadFailCount = data.upload_fail_count;
          this.feedbackFileUrl = data.feedback_file_url;
          this.$message.error(this.$t('936'));
        } else if (data.upload_result_state === 3) {
          // 全部失败
          this.uploadTotalCount = data.upload_total_count;
          this.uploadSuccessCount = data.upload_success_count;
          this.uploadFailCount = data.upload_fail_count;
          this.feedbackFileUrl = data.feedback_file_url;
          this.$message.error(this.$t('937'));
        }
      }
    },
    handleOpenUrl: function handleOpenUrl() {
      window.open(this.feedbackFileUrl);
    },
    // 上传失败
    // err, file, fileList
    errorHandle: function errorHandle(err, file) {
      var index = this.$refs.upload.uploadFiles.findIndex(function (v) {
        return v.name === file.name;
      });
      this.$refs.upload.uploadFiles.splice(index, 1);
      this.$message.error('upload error');
      throw err;
    },
    resetDate: function resetDate() {
      this.uploadTotalCount = 0; // 总数
      this.uploadSuccessCount = 0; // 成功数
      this.uploadFailCount = 0; // 失败数
      this.feedbackFileUrl = '';
      this.uploadStatus = false;
    },
    // 弹窗关闭时
    closeHandle: function closeHandle() {
      this.reset();
      this.resetDate();
    },
    reset: function reset() {
      this.$refs.upload.clearFiles();
      this.successFileList = [];
    },
    doSubmit: function doSubmit() {
      this.visible = false;
      this.resetDate();
      this.$emit('submit');
    }
  },
  watch: {
    successFileList: {
      handler: function handler(val) {
        if (val.length) this.$emit('uploadSuccess', val);
      },
      deep: true
    }
  }
};